import {
  GET_ONBOARDING_USERS, GET_ONBOARDING_USERS_SUCCESS, GET_ONBOARDING_USERS_FAILURE,
  GET_ONBOARDING_USER, GET_ONBOARDING_USER_SUCCESS, GET_ONBOARDING_USER_FAILURE,
  CREATE_ONBOARDING_USER, CREATE_ONBOARDING_USER_SUCCESS, CREATE_ONBOARDING_USER_FAILURE,
  RESEND_ONBOARDING_INVITATION, CREATE_EMPLOYMENT_CONTRACT,
  APPROVE_ONBOARDING_DOCUMENT, REJECT_ONBOARDING_DOCUMENT,
  APPROVE_ONBOARDING_SUBMISSION, REJECT_ONBOARDING_SUBMISSION,
  ONBOARDING_ACTION_SUCCESS, ONBOARDING_ACTION_FAILURE,
  GET_MY_NUMBER, GET_MY_NUMBER_SUCCESS, GET_MY_NUMBER_FAILURE,
  GET_ONBOARDING_SHIFT_CLASSES, UPDATE_ONBOARDING_USER_PROFILE, REGISTER_ONBOARDING_USER
} from './mutation-types'
import constant from '../constant'

//
// 入社手続き（F-NEW-01 / 02 / 05 / 06 / 07 / 11）
//
export default {
  state: {
    onboardingShiftClasses: [],
    onboardingUsers: null,
    onboardingUser: null,
    onboardingDocuments: null,
    onboardingContract: null,
    // 【本登録】の事前チェック結果（ready / can_force / items。No18）
    onboardingRegisterChecks: null,
    onboardingNotify: null,
    onboardingForbidden: false,
    myNumber: null
  },
  getters: {
    onboardingRegisterChecks: state => {
      return state.onboardingRegisterChecks
    },
    onboardingShiftClasses: state => {
      return state.onboardingShiftClasses
    },
    onboardingUsers: state => {
      return state.onboardingUsers
    },
    onboardingUser: state => {
      return state.onboardingUser
    },
    onboardingDocuments: state => {
      return state.onboardingDocuments
    },
    onboardingContract: state => {
      return state.onboardingContract
    },
    onboardingNotify: state => {
      return state.onboardingNotify
    },
    onboardingForbidden: state => {
      return state.onboardingForbidden
    },
    myNumber: state => {
      return state.myNumber
    }
  },
  actions: {
    // 入社手続き対象者一覧
    [GET_ONBOARDING_USERS] ({dispatch, state, commit}, params = null) {
      state.onboardingForbidden = false
      return dispatch('apiGet', {url: '/master/onboarding/users', data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_ONBOARDING_USERS_FAILURE, res.data)
          } else {
            commit(GET_ONBOARDING_USERS_SUCCESS, {data: res.data, callback: params ? params.callback : null})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.onboardingForbidden = true
        }
        console.log('GET_ONBOARDING_USERS error', error)
        commit(GET_ONBOARDING_USERS_FAILURE, {})
        if (params && params.callback) params.callback()
      })
    },
    // 個別ステータス・書類一覧
    [GET_ONBOARDING_USER] ({dispatch, state, commit}, params) {
      state.onboardingForbidden = false
      return dispatch('apiGet', {url: '/master/onboarding/users/' + params.id, data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_ONBOARDING_USER_FAILURE, res.data)
          } else {
            commit(GET_ONBOARDING_USER_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.onboardingForbidden = true
        }
        console.log('GET_ONBOARDING_USER error', error)
        commit(GET_ONBOARDING_USER_FAILURE, {})
        if (params.callback) params.callback()
      })
    },
    // 仮登録（＋招待メール送信）
    [CREATE_ONBOARDING_USER] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/onboarding/users', data: params.data, isLoading: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CREATE_ONBOARDING_USER_FAILURE, res.data)
          } else {
            commit(CREATE_ONBOARDING_USER_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '仮登録に失敗しました。'
        commit(CREATE_ONBOARDING_USER_FAILURE, {error: message})
      })
    },
    // 招待メール再送
    [RESEND_ONBOARDING_INVITATION] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/onboarding/users/' + params.id + '/resend_invitation', data: {}})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        console.log('RESEND_ONBOARDING_INVITATION error', error)
        commit(ONBOARDING_ACTION_FAILURE, {error: '再送に失敗しました。'})
      })
    },
    // 労働条件通知書の生成
    [CREATE_EMPLOYMENT_CONTRACT] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/onboarding/users/' + params.id + '/contract', data: params.data})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: {success: '労働条件通知書を作成しました。'}, callback: params.callback})
        }
      })
      .catch(error => {
        console.log('CREATE_EMPLOYMENT_CONTRACT error', error)
        commit(ONBOARDING_ACTION_FAILURE, {error: '労働条件通知書の作成に失敗しました。'})
      })
    },
    // 承認
    [APPROVE_ONBOARDING_DOCUMENT] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/onboarding/documents/' + params.id + '/approve', data: {}})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '承認に失敗しました。'
        commit(ONBOARDING_ACTION_FAILURE, {error: message})
      })
    },
    // 差し戻し
    [REJECT_ONBOARDING_DOCUMENT] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/onboarding/documents/' + params.id + '/reject', data: params.data})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '差戻しに失敗しました。'
        commit(ONBOARDING_ACTION_FAILURE, {error: message})
      })
    },
    // 提出回次単位の承認（書類種別ごとに複数枚をまとめて承認する）
    [APPROVE_ONBOARDING_SUBMISSION] ({dispatch, state, commit}, params) {
      var url = '/master/onboarding/users/' + params.userId + '/documents/' + params.documentType + '/approve'
      return dispatch('apiPut', {url: url, data: {}})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '承認に失敗しました。'
        commit(ONBOARDING_ACTION_FAILURE, {error: message})
      })
    },
    // 提出回次単位の差し戻し
    [REJECT_ONBOARDING_SUBMISSION] ({dispatch, state, commit}, params) {
      var url = '/master/onboarding/users/' + params.userId + '/documents/' + params.documentType + '/reject'
      return dispatch('apiPut', {url: url, data: params.data})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'この操作を行う権限がありません。' : '差戻しに失敗しました。'
        commit(ONBOARDING_ACTION_FAILURE, {error: message})
      })
    },
    // マイナンバー閲覧（人事管理責任者のみ）
    // パートの仮登録・確認画面で選ぶ配属店舗のシフト区分
    [GET_ONBOARDING_SHIFT_CLASSES] ({dispatch, state, commit}, params) {
      return dispatch('apiGet', {url: '/master/onboarding/users/shift_classes', data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          state.onboardingShiftClasses = res.data.shift_classes || []
        }
      })
      .catch(error => {
        console.log('GET_ONBOARDING_SHIFT_CLASSES error', error)
        state.onboardingShiftClasses = []
      })
    },
    // 本人情報の訂正（確認画面）
    [UPDATE_ONBOARDING_USER_PROFILE] ({dispatch, state, commit}, params) {
      return dispatch('apiPatch', {url: '/master/onboarding/users/' + params.id + '/profile', data: params.data})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.data && error.response.data.error)
          ? error.response.data.error : '本人情報の保存に失敗しました。'
        commit(ONBOARDING_ACTION_FAILURE, {error: message})
      })
    },
    // 本登録（入社手続きの完了。No18）。事前チェックの不足は 422 で理由が返る。force: true は人事管理責任者の強制登録
    [REGISTER_ONBOARDING_USER] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/onboarding/users/' + params.id + '/register', data: params.data})
      .then(res => {
        if (res.data.error) {
          commit(ONBOARDING_ACTION_FAILURE, res.data)
        } else {
          commit(ONBOARDING_ACTION_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = '本登録に失敗しました。'
        if (error.response && error.response.status === 403) {
          message = 'この操作を行う権限がありません。'
        } else if (error.response && error.response.data && error.response.data.error) {
          message = error.response.data.error
        }
        commit(ONBOARDING_ACTION_FAILURE, {error: message})
      })
    },
    [GET_MY_NUMBER] ({dispatch, state, commit}, params) {
      state.myNumber = null
      return dispatch('apiGet', {url: '/master/users/' + params.id + '/my_number', data: {}})
      .then(res => {
        if (res.data.error) {
          commit(GET_MY_NUMBER_FAILURE, res.data)
        } else {
          commit(GET_MY_NUMBER_SUCCESS, {data: res.data, callback: params.callback})
        }
      })
      .catch(error => {
        var message = (error.response && error.response.status === 403)
          ? 'マイナンバーを閲覧する権限がありません。' : '取得に失敗しました。'
        commit(GET_MY_NUMBER_FAILURE, {error: message})
      })
    }
  },
  mutations: {
    [GET_ONBOARDING_USERS_FAILURE] (state, data) {
      console.log('GET_ONBOARDING_USERS_FAILURE')
      state.onboardingUsers = []
    },
    [GET_ONBOARDING_USERS_SUCCESS] (state, data) {
      console.log('GET_ONBOARDING_USERS_SUCCESS')
      state.onboardingUsers = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [GET_ONBOARDING_USER_FAILURE] (state, data) {
      console.log('GET_ONBOARDING_USER_FAILURE')
      state.onboardingUser = null
      state.onboardingDocuments = []
      state.onboardingRegisterChecks = null
    },
    [GET_ONBOARDING_USER_SUCCESS] (state, data) {
      console.log('GET_ONBOARDING_USER_SUCCESS')
      state.onboardingUser = data.data.user
      state.onboardingDocuments = data.data.documents
      state.onboardingContract = data.data.contract
      state.onboardingRegisterChecks = data.data.register_checks || null
      if (data.callback) {
        data.callback()
      }
    },
    [CREATE_ONBOARDING_USER_FAILURE] (state, data) {
      console.log('CREATE_ONBOARDING_USER_FAILURE')
      state.onboardingNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.onboardingNotify = null
      }, constant.notifyShowTime.long)
    },
    [CREATE_ONBOARDING_USER_SUCCESS] (state, data) {
      console.log('CREATE_ONBOARDING_USER_SUCCESS')
      var message = data.data.success
      if (data.data.mail_sent === false) {
        message += '（招待メールの送信に失敗しました。メールアドレスをご確認のうえ再送してください）'
      }
      state.onboardingNotify = {message: message, danger: false}
      setTimeout(() => {
        state.onboardingNotify = null
      }, constant.notifyShowTime.long)
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [ONBOARDING_ACTION_FAILURE] (state, data) {
      console.log('ONBOARDING_ACTION_FAILURE')
      state.onboardingNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.onboardingNotify = null
      }, constant.notifyShowTime.long)
    },
    [ONBOARDING_ACTION_SUCCESS] (state, data) {
      console.log('ONBOARDING_ACTION_SUCCESS')
      state.onboardingNotify = {message: data.data.success, danger: false}
      setTimeout(() => {
        state.onboardingNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [GET_MY_NUMBER_FAILURE] (state, data) {
      console.log('GET_MY_NUMBER_FAILURE')
      state.onboardingNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.onboardingNotify = null
      }, constant.notifyShowTime.long)
    },
    [GET_MY_NUMBER_SUCCESS] (state, data) {
      console.log('GET_MY_NUMBER_SUCCESS')
      state.myNumber = data.data
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/onboarding.js